var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReactivationTokenModal',{attrs:{"open":_vm.showAddReactivationTokenModal},on:{"update:open":function($event){_vm.showAddReactivationTokenModal=$event},"createReactivationToken":_vm.createReactivationToken}})}
var staticRenderFns = []

export { render, staticRenderFns }